import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading } from '@/decorators';

var BounceCfgPage = function (_super) {
  __extends(BounceCfgPage, _super);

  function BounceCfgPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.bounceCfgList = [];
    _this.loadingStatus = false;
    _this.columns = [];
    return _this;
  }

  BounceCfgPage.prototype.created = function () {
    this.columns = [{
      title: this.t('退件类型'),
      dataIndex: 'cass_type_text',
      filterEmpty: true
    }, {
      title: this.t('退货仓库（区域）'),
      scopedSlots: {
        customRender: 'warehouse_code'
      },
      filterEmpty: true
    }, {
      title: this.t('状态'),
      dataIndex: 'cass_status_text',
      filterEmpty: true
    }, {
      title: this.t('集货仓'),
      dataIndex: 'collect_warehouse_str',
      filterEmpty: true
    }, {
      title: this.t('退货服务类型'),
      scopedSlots: {
        customRender: 'service_type_list'
      },
      filterEmpty: true
    }];
    this.queryBounceCfgList();
  };

  BounceCfgPage.prototype.joinText = function (data) {
    if (data instanceof Array) {
      return data.join('/');
    }

    return '';
  };

  BounceCfgPage.prototype.queryBounceCfgList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.order.queryBounceCfgList()];

          case 1:
            data = _a.sent().data;
            this.bounceCfgList = data;
            return [2];
        }
      });
    });
  };

  __decorate([loading('loadingStatus')], BounceCfgPage.prototype, "queryBounceCfgList", null);

  BounceCfgPage = __decorate([Component], BounceCfgPage);
  return BounceCfgPage;
}(Vue);

export default BounceCfgPage;